module.exports = __webpack_public_path__ + "static/media/mood_1.f6efd0ee.svg";